<script setup lang="ts">
import { LanguageSelector } from 'r3ui-lib';
import Cookies from 'js-cookie';
import { getBrowserLocale } from '~/utils/helpers';

const savedLocale = Cookies.get('i18n_redirected');
const defaultLocale = savedLocale || getBrowserLocale();
const localeModel = ref(defaultLocale);
const { locale, locales, setLocale } = useI18n();

function setLocaleHandler(e: string) {
  if (e === locale.value) return false;
  setLocale(e as typeof locale.value);
  window.location.reload();
}

const localeOptions = computed(() => {
  return locales.value.map((i: { code: string; name?: string }) => {
    return {
      id: i.code,
      label: i.name,
    };
  });
});
</script>

<template>
  <LanguageSelector
    v-model="localeModel"
    :options="localeOptions"
    @update:model-value="setLocaleHandler"
  />
</template>
